import React from 'react';
import styles from './LoadingSkeleton.module.scss';

export default function LoadingSkeleton({ rows = 6, cols = 4 }) {
  return (
    <div className={styles.wrap} aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }).map((_, ri) => (
        <div key={ri} className={styles.row}>
          {Array.from({ length: cols }).map((_, ci) => (
            <div key={ci} className={styles.cell} />
          ))}
        </div>
      ))}
    </div>
  );
}
